import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { ToolsAndEquipmentManualsService } from '../tools-and-equipment-manuals.service';
import { NgIf, NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-tool-report-sidebar',
    templateUrl: './tool-report-sidebar.component.html',
    styleUrls: ['./tool-report-sidebar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        FormsModule,
        NgStyle,
    ],
})
export class ToolReportSidebarComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  public toolReportTitles: any[];
  private subscription: ISubscription[] = [];
  public docTitle = 'Complete Tool Report';
  public toolReports: any[];
  APP_SETTINGS : any;
  public activeLink = false;

  public inputSIB;
  public inputLocation;
  public inputSeries;
  public checkAutoships: boolean;
  public checkExternalMFR: boolean;
  private filter = { bulletinDisplayNumber: '', location: '', series: '', autoShip: false, externalMfrgToolWarranty: false };

  username: string;

  constructor(private utilityService: UtilityService,
    private toolsAndEquipManualService: ToolsAndEquipmentManualsService,
    private authService: AuthService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  ngOnInit() {
this.APP_SETTINGS = APP_SETTINGS;
  }
  ngOnInit2() {
    this.username = this.authService.getUserName();
    this.subscription = [];
    this.toolReports = [];
    // if (this.toolReports.length < 1) {
    //   this.subscription.push(this.toolsAndEquipManualService.getAllToolsReport().subscribe(data => {
    //     this.toolReportTitles = [];
    //     let reportDetails = data['content'];
    //     reportDetails = reportDetails.sort((a, b) => {
    //       if (a['title'] > b['title']) {
    //         return 1;
    //       }else if (a['title'] < b['title']) {
    //         return -1;
    //       }else {
    //         return 0;
    //       }
    //     });
    //     this.toolReports = reportDetails;
    //   }));
    // }
    // call respective all/new/history api based on selected section in report content
    // this.utilityService.subscribeActiveTab$.subscribe(data => {
    //   if (typeof data !== 'boolean') {
    //     switch (data) {
    //       case 'all':
    //         this.subscription.push(this.toolsAndEquipManualService.getAllToolsReport().subscribe(value => {
    //           this.toolReportTitles = [];
    //           this.toolReports = value['content'];
    //         }));
    //         break;
    //       case 'new':
    //         this.subscription.push(this.toolsAndEquipManualService.getNewToolsReport().subscribe(value => {
    //           this.toolReportTitles = [];
    //           this.toolReports = value;
    //         }));
    //         break;
    //       case 'history':
    //         this.subscription.push(this.toolsAndEquipManualService.getUserToolReportHistory(this.username).subscribe(value => {
    //           this.toolReportTitles = [];
    //           this.toolReports = value;
    //         }));
    //         break;
    //     }
    //     this.docTitle = '';
    //   }
    // });
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  highlightLink(report) {
    // for tablet and mobile versions report is object, which is the title in case of desktop and Ipad
    if (report === 'Complete Tool Report' || report === 'Autoship Tool Report') {
      this.utilityService.publishInfo(this.activeLink);
      this.utilityService.publishActiveReportObject(report);
    }
    this.docTitle = report;
  }
  applyFilter() {
    this.filter = {
      bulletinDisplayNumber: this.inputSIB,
      location: this.inputLocation,
      series: this.inputSeries,
      autoShip: this.checkAutoships,
      externalMfrgToolWarranty: this.checkExternalMFR
    };

    this.utilityService.publishFilterCriteria(this.filter);
  }
  cancelFilter() {
    this.inputSIB = this.inputLocation = this.inputSeries = '';
    this.checkAutoships = this.checkExternalMFR = false;
    this.filter = { bulletinDisplayNumber: '', location: '', series: '', autoShip: false, externalMfrgToolWarranty: false };
    this.utilityService.publishFilterCriteria(this.filter);
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }
}
